export const EMPLOYEE_TYPES_ALIAS = {
  EMPLOYEE: 'EMPLOYEE',
  CONTRACTOR: 'CONTRACTOR',
  INTERN: 'INTERN',
};

export const EMPLOYEE_TYPES = {
  [EMPLOYEE_TYPES_ALIAS.EMPLOYEE]: 'Employee',
  [EMPLOYEE_TYPES_ALIAS.CONTRACTOR]: 'Contractor',
  [EMPLOYEE_TYPES_ALIAS.INTERN]: 'Intern',
};

export const EMPLOYEE_WORKING_STATUSES = {
  ACTIVE: 'Active',
  IN_DISMISSAL: 'In Dismissal',
  DISMISSED: 'Dismissed',
  RELOCATION: 'Relocation',
};

export const EMPLOYEE_STATUS = {
  DISMISSED: 'DISMISSED',
  ACTIVE: 'ACTIVE',
  IN_DISMISSAL: 'IN_DISMISSAL',
  RELOCATION: 'RELOCATION',
};

export const EMPLOYEE_STATE_KEYS = {
  NEW: 'NEW',
  FINALIZED: 'FINALIZED',
};

export const EMPLOYEE_WORKPLACE_LOCATION_IDS = {
  OFFICE_ONLY: 'OFFICE_ONLY',
  REMOTE_ONLY: 'REMOTE_ONLY',
  HYBRID: 'HYBRID',
};

export const EMPLOYEE_WORKPLACE_LOCATION = {
  [EMPLOYEE_WORKPLACE_LOCATION_IDS.OFFICE_ONLY]: 'Office only',
  [EMPLOYEE_WORKPLACE_LOCATION_IDS.REMOTE_ONLY]: 'Remote only',
  [EMPLOYEE_WORKPLACE_LOCATION_IDS.HYBRID]: 'Hybrid',
};

export const FINALIZE_KEY = 'state';
export const FINALIZE_STATE = 'FINALIZE';

export const RESOURCE_URL = '/employees';

export const MAP_EMPLOYEE_STATUS = {
  ACTIVE: 'Active',
  PROBATION: 'Probation',
  IN_DISMISSAL: 'In dismissal',
  DISMISSAL: 'Dismissal',
  DISMISSED: 'Dismissed',
  RELOCATION: 'Relocation',
};

const EMPLOYEE_DASHBOARD_COLORS = {
  SAFE: 'var(--mui-palette-border-success)',
  MONITORING: 'var(--mui-palette-border-warning)',
  CRITICAL: 'var(--mui-palette-border-error)',
  ESCALATION: 'var(--mui-palette-border-error)',
};

export interface HealthcheckStatusConfig {
  textColor: string;
  buttonColor: string;
}

export const HEALTHCHECK_CONFIG: Record<keyof typeof EMPLOYEE_ZONES_ALIASES, HealthcheckStatusConfig> = {
  SAFE: {
    textColor: EMPLOYEE_DASHBOARD_COLORS.SAFE,
    buttonColor: EMPLOYEE_DASHBOARD_COLORS.SAFE,
  },
  MONITORING: {
    textColor: EMPLOYEE_DASHBOARD_COLORS.MONITORING,
    buttonColor: EMPLOYEE_DASHBOARD_COLORS.MONITORING,
  },
  CRITICAL: {
    textColor: EMPLOYEE_DASHBOARD_COLORS.CRITICAL,
    buttonColor: EMPLOYEE_DASHBOARD_COLORS.CRITICAL,
  },
  ESCALATION: {
    textColor: EMPLOYEE_DASHBOARD_COLORS.ESCALATION,
    buttonColor: EMPLOYEE_DASHBOARD_COLORS.ESCALATION,
  },
} as Record<keyof typeof EMPLOYEE_ZONES_ALIASES, HealthcheckStatusConfig>;

export const EMPLOYEE_ZONES_ALIASES = {
  SAFE: 'SAFE',
  MONITORING: 'MONITORING',
  CRITICAL: 'CRITICAL',
  ESCALATION: 'ESCALATION',
};
